import { UserAvatar } from '@/components/ui/name-avatar';
import { DefaultTooltip } from '@/components';

const renderMultiAvatars = (data) => {
  if (!data || (Array.isArray(data) && data.length === 0)) return <span>-</span>;
  const users = Array.isArray(data) ? data : [data];
  return (
    <div className="flex items-center ml-2.5">
      {users.map((user) => {
        const userName = user.first_name ? `${user.first_name} ${user.last_name}` : 'Not Available';
        const fullName = userName;
        const avatar = user.profile_image;

        return (
          <div key={user.id} className="flex items-center gap-1">
            <DefaultTooltip title={fullName} placement="top" className="max-w-48">
              {avatar ? (
                <span className='w-full'>
                  <img
                    src={avatar}
                    className="size-6.5 rounded-full border-2 border-success -ml-2.5 hover:z-10 max-w-max relative"
                    alt="user image"
                  />
                </span>
              ) : (
                <span>
                  <UserAvatar
                    name={fullName}
                    className="!size-6.5 !text-xs !border !border-primary -ml-2.5 hover:z-10"
                  />
                </span>
              )}
            </DefaultTooltip>
          </div>
        );
      })}
    </div>
  );
};

export { renderMultiAvatars }